export default __webpack_public_path__ + "static/media/notImg.2644a3b3.png";